import { useTRPC } from "../../../../trpc.js";
import type { BasicUsageParameters, SpecificUsageParameters } from "../UsageChartWrapper.js";
import { useQuery } from "@tanstack/react-query";
import { CACHING_OPTIONS } from "../constants/cachingOptions.js";

export function useAssistantUsage(p: BasicUsageParameters) {
  const trpc = useTRPC();

  const {
    data: assistantUsage,
    isLoading: isLoadingAssistantUsage,
    isError: isErrorAssistantUsage,
  } = useQuery(trpc.getAssistantUsageHist.queryOptions(p, CACHING_OPTIONS));

  return { assistantUsage, isLoadingAssistantUsage, isErrorAssistantUsage };
};

export function useCustomStylesUsage(p: BasicUsageParameters) {
  const trpc = useTRPC();

  const {
    data: customStylesUsage = [],
    isLoading: isLoadingStyles,
    isError: isErrorStyles,
  } = useQuery(trpc.getCustomStyleUsage.queryOptions(p, CACHING_OPTIONS));

  return { customStylesUsage, isLoadingStyles, isErrorStyles };
};

export function useCustomTilesetsUsage(p: BasicUsageParameters) {
  const trpc = useTRPC();

  const {
    data: customTilesetsUsage = [],
    isLoading: isLoadingTilesets,
    isError: isErrorTilesets,
  } = useQuery(trpc.getCustomTilesetUsage.queryOptions(p, CACHING_OPTIONS));

  return { customTilesetsUsage, isLoadingTilesets, isErrorTilesets };
};

export function useStyleJsonUsage(p: SpecificUsageParameters) {
  const trpc = useTRPC();

  const {
    data: styleJsonUsage = [],
    isLoading: isLoadingStyleJsonUsage,
    isError: isErrorStyleJsonUsage,
  } = useQuery(trpc.getStyleJsonUsage.queryOptions(p, CACHING_OPTIONS));

  return { styleJsonUsage, isLoadingStyleJsonUsage, isErrorStyleJsonUsage };
};

export function useProcessingUsage(p: SpecificUsageParameters) {
  const trpc = useTRPC();

  const {
    data: processingUsage = [],
    isLoading: isLoadingProcessingUsage,
    isError: isErrorProcessingUsage,
  } = useQuery(trpc.getProcessingUsage.queryOptions(p, CACHING_OPTIONS));

  return { processingUsage, isLoadingProcessingUsage, isErrorProcessingUsage };
};

export function useStorageUsage(p: BasicUsageParameters) {
  const trpc = useTRPC();

  const {
    data: storageUsage = [],
    isLoading: isLoadingStorage,
    isError: isErrorStorage,
  } = useQuery(trpc.getStorageUsageEvents.queryOptions(p, CACHING_OPTIONS));

  return { storageUsage, isLoadingStorage, isErrorStorage };
};

export function useTilesRequestsUsage(p: SpecificUsageParameters) {
  const trpc = useTRPC();

  const {
    data: tilesRequestsUsage = [],
    isLoading: isLoadingTilesUsage,
    isError: isErrorTilesUsage,
  } = useQuery(trpc.getTilesetTileUsage.queryOptions(p, CACHING_OPTIONS));

  return { tilesRequestsUsage, isLoadingTilesUsage, isErrorTilesUsage };
};

export function useTeamSeatsUsage(p: BasicUsageParameters) {
  const trpc = useTRPC();

  const {
    data: teamSeatsUsage = [],
    isLoading: isLoadingTeamSeats,
    isError: isErrorTeamSeats,
  } = useQuery(trpc.getTeamSeatsUsageHist.queryOptions(p, CACHING_OPTIONS));

  return { teamSeatsUsage, isLoadingTeamSeats, isErrorTeamSeats };
}
